import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {tagPicker_template} from "./tagPicker_template";
import {imagePicker_template} from '../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template';
import {filterArticle_template} from "./filterArticle_template";
import {filterAutocomplete_template} from "./filterAutocomplete_template";
import {
    filterDropdown_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {imagePickerHelper} from '../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper';

declare var ko: any;

export class newsletterInteractionEmailEdit_template extends vnTemplate {

    public imagePicker: imagePicker_template;
    public tagPicker: tagPicker_template;
    public articleFilter: filterArticle_template
    public filterProducts: filterAutocomplete_template;
    public filterAffiliates: filterAutocomplete_template;
    public filterProductTypes: filterAutocomplete_template;
    public typeSelector: filterDropdown_template;
    public templateSelector: filterDropdown_template;
    public imagePickerHelper: imagePickerHelper;


    protected getTemplateHtml(): string {

        return `
            <div class="w-form w-form-large">
                <div class="form-header">
                    <h3 class="form-title">Newsletter Interaction Email</h3>
                    <h3 class="form-title" data-bind="text: name"></h3>
                    <button data-bind="event: { click: onClickCancelEdit }" class="close-button icon i-close-2" type="button"></button>
                    
                </div>
                <div class="w-form-body">
                    <div class="form-body">
                       
                        <div class="form-group">
                            <label for="subject" class="form-label">Subject</label>
                            <div class="row link">
                                <input id="subject" data-bind="value: subject" type="text" class="input-text">
                            </div>
                        </div>
                        
                        <div class="form-group">
                            <label for="previewText" class="form-label">Preview Text</label>
                            <div class="row link">
                                <input id="previewText" data-bind="value: previewText" type="text" class="input-text">
                            </div>
                        </div>
                        <div class="form-group-row">
                            
                            <div class="form-group">
                                 <label for="logoUrl" class="form-label">Type</label>
                                 ${this.typeSelector.getHtmlBuild()}
                            </div> 
                            
                            <div class="form-group">
                                 <label for="logoUrl" class="form-label">Template</label>
                                 ${this.templateSelector.getHtmlBuild()}
                            </div> 

                        </div>
                    </div>
                </div>
                
                <div class="w-form-body">
                    <div class="form-body w-interactions-email">    
                        <div class="form-group">
                             <label for="contentText" class="form-label">Content</label>
                             <textarea id="contentText" data-bind="value: content" ></textarea>
                        </div> 
                        
                        <div class="form-group">
                             <label for="signatureText" class="form-label">Signature</label>
                             <textarea id="signatureText" data-bind="value: signature" ></textarea>
                        </div>                         
                    </div> 
                </div>  
                
                 <div class="form-footer">                
                    <button data-bind="event: { click: onClickCancelEdit }" class="btn " type="button">Cancel</button>
                    <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>            
                </div>
            </div>  
            
            ` + this.imagePicker.getHtmlBuild() + `
            ` + this.tagPicker.getHtmlBuild() + `
            
            <div data-bind="css: { 'is-visible': isArticleInsertPopUpVisible }" class="w-lightbox light-theme lightbox-embed">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Article</h3>
                            <button type="button" class="close-button icon i-close-2" data-bind="event: { click: onClickCloseArticlePopUp }" ></button>
                        </div>
                        <div class="form-body w-article-picker" style="padding:2rem">
                            ${this.articleFilter.getHtmlBuild()}
                            <div class="preview" data-bind="visible: articleInsertPreviewCode">
                                <div class="form-group">
                                    <div class="scrollable" style="max-width:50vw;"  data-bind="html: articleInsertPreviewCode, disable: true" ></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickCloseArticlePopUp }" class="btn ">Cancel</button>
                            <button type="button" data-bind="disable: articleInsertPreviewCode() == '',  event: { click: onClickInsertIntoEditor }" class="btn highlight">Insert</button>
                        </div>
                    </div>
                </div>
            </div>
            `;

    }

    protected getTemplateName(): string {

        return "newsletterInteractionEmailEdit-template";
    }

    protected getMainElementClasses(): Array<string> {

        return ["div"];
    }

    public showTagPicker(mode, target){

        this.tagPicker.setMode(mode);
        this.tagPicker.setTarget(target);
        this.setTagPickerTarget(target);
        this.tagPicker.show();
    }

    public setTagPickerTarget(tagPickerTarget){

        this.getTemplateViewModel().tagPickerTarget(tagPickerTarget);
    }

    protected initPartial() {

        this.imagePicker = new imagePicker_template("imagePicker", this.getTemplateViewModel(), this.caller);
        this.imagePicker.setNumberOfRecentImages(50);

        this.tagPicker = new tagPicker_template("tagPicker", this.getTemplateViewModel(), this.caller);
        this.tagPicker.setParent(this);

        this.articleFilter = new filterArticle_template("filterArticle", this.getTemplateViewModel(), this.caller);
        this.articleFilter.setShowDetails(true);
        this.articleFilter.setIsLoadingAnimationEnable(true);

        this.filterProducts = new filterAutocomplete_template("filterAutocompleteProduct_template", this.getTemplateViewModel(), this.caller);
        this.filterProducts.setClearInputConfirmMessage("Are you sure you want to change the product name? Newly entered product specifications and selected fields will be lost");
        this.filterProducts.setAddNewClearConfirmMessage("Are you sure you want to add a new product name? Newly entered product specifications and selected fields will be lost");
        this.filterProducts.setAddNewOptionEnabled(true);
        this.filterProducts.setHasDisplayNameComplement(true);
        this.filterProducts.setNumberOfChars( 1 );
        this.filterProducts.setPlaceholderAndLabel( "Product" );
        this.filterProducts.setOptionType("Product name");

        this.filterAffiliates = new filterAutocomplete_template("filterAutocompleteAffiliate_template", this.getTemplateViewModel(), this.caller);
        this.filterAffiliates.setAddNewOptionEnabled(true);
        this.filterAffiliates.setNumberOfChars( 1 );
        this.filterAffiliates.setPlaceholderAndLabel( "Affiliate Partner" );
        this.filterAffiliates.setOptionType("Affiliate Partner");

        this.filterProductTypes = new filterAutocomplete_template("filterAutocompleteProductType_template", this.getTemplateViewModel(), this.caller);
        this.filterProductTypes.setClearInputConfirmMessage("Are you sure you want to change the product type? Newly entered product specifications and selected fields will be lost");
        this.filterProductTypes.setAddNewClearConfirmMessage("Are you sure you want to add a new product type? Newly entered product specifications and selected fields will be lost");
        this.filterProductTypes.setPlaceholderAndLabel( 'Product Type' );
        this.filterProductTypes.setOptionType("Product Type");
        this.filterProductTypes.setNumberOfChars( 1 );
        this.filterProductTypes.setAddNewOptionEnabled(true);
        
        this.typeSelector = new filterDropdown_template('typeSelector', this.getTemplateViewModel(), this.caller);
        this.typeSelector.setLabel('Template');
        
        this.templateSelector = new filterDropdown_template('templateSelector', this.getTemplateViewModel(), this.caller);
        this.templateSelector.setLabel('Template');

        this.imagePickerHelper = new imagePickerHelper(
            this.imagePicker,
            this.caller.viewModel, 
            this.caller.getVnAppZone(),
            this.caller
        );
    }

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable(""),
            subject: ko.observable(""),
            previewText: ko.observable(""),
            content: ko.observable(""),
            signature: ko.observable(""),
            isArticleInsertPopUpVisible: ko.observable(false),
            articleInsertPreviewCode: ko.observable(''),
            imagePickerTarget: ko.observable(null),
            tagPickerTarget: ko.observable(null),
            articlePickerTarget: ko.observable(null),
            permissions: ko.observableArray(this.initPermissions([ 'newsletter_interaction_emails'])),
            onClickCancelEdit: function (data, event) {
                self.cancelEdit();

            },
            onClickSave: function (data, event) {
                self.onClickSave()
            },
            onClickCloseArticlePopUp: function (data, event) {
                self.onClickCloseArticlePopUp();
            },
            onClickInsertIntoEditor: function (data, event) {
                self.onClickInsertIntoEditor();
            },
        }
    }

    getViewModelForRequest(): any {

        return {
            idInteractionEmail: this.getTemplateViewModel().id(),
            subject: this.getTemplateViewModel().subject(),
            previewText: this.getTemplateViewModel().previewText(),
            type: this.typeSelector.getTemplateViewModel().selectedOption,
            template: this.templateSelector.getTemplateViewModel().selectedOption,
            content: this.getTemplateViewModel().content(),
            signature: this.getTemplateViewModel().signature(),
        };
    }

    public setId( id) {

        this.getTemplateViewModel().id(id);
    }

    public setTypes( options) {

        options.unshift({'id':null,'name':'Select An Option'});
        this.typeSelector.setOptions(options);
    }
   
    public setTemplates( options) {

        options.unshift({'id':null,'name':'Select An Option'});
        this.templateSelector.setOptions(options);
    }

    public setSubject(subject) {

        this.getTemplateViewModel().subject(subject)
    }
    
    public setPreviewText(previewText) {

        this.getTemplateViewModel().previewText(previewText)
    }

    public setContent( content) {

        this.getTemplateViewModel().content(content);
    }

    public setSignature( signature) {

        this.getTemplateViewModel().signature(signature);
    }
   
    public showImagePicker(mode,target, keyword = null){

        this.imagePicker.setMode(mode);
        this.setImagePickerTarget(target);
        this.imagePicker.setTarget(target);
        this.caller.getImageData(keyword);
        if(mode == "multi-select"){
            this.caller.getImagesInContent(target);
        }
        this.imagePicker.show();
    }

    public getImagePickerTarget(){

        return this.getTemplateViewModel().imagePickerTarget();
    }

    public setImagePickerTarget(imagePickerTarget){

        this.getTemplateViewModel().imagePickerTarget(imagePickerTarget);
    }

    public getArticlePickerTarget(){

        return this.getTemplateViewModel().articlePickerTarget();
    }

    public setArticlePickerTarget(articlePickerTarget){

        this.getTemplateViewModel().articlePickerTarget(articlePickerTarget);
    }

    public onClickSave(){

        this.caller.save();
    }

    public isSectionForTagPicker(sectionName: string): boolean {

        let tpSections = ['featuredTag'];

        let fs =  tpSections.filter((s) => s == sectionName );

        return (fs.length > 0);
    }

    public editTagElement(tagElement, editor){

        this.showTagPicker("in-content", editor);
        this.tagPicker.editTagElement(tagElement);
    }

    public editTagGroup(groupElement, editor){

        this.showTagPicker("in-content", editor);
        this.tagPicker.setTagGroupElement(groupElement);
    }

    public initTagPickerCkEditors(): void{

        this.tagPicker.initializeCkEditors();
    }

    public getPermissions() {

        return this.getTemplateViewModel().permissions();
    }

    public toggleArticleInsertPopUp(bool){

        this.getTemplateViewModel().isArticleInsertPopUpVisible(bool)
    }

    public setArticleInsertPreviewCode(html){

        this.getTemplateViewModel().articleInsertPreviewCode(html)
    }

    public onClickCloseArticlePopUp(){

        this.toggleArticleInsertPopUp(false);
        this.resetArticleInsertPopUp();
    }

    public onClickInsertIntoEditor(){

        let html = this.getTemplateViewModel().articleInsertPreviewCode();
        this.caller.insertIntoEditor(html);
        this.resetArticleInsertPopUp();
        this.toggleArticleInsertPopUp(false);
    }

    public resetArticleInsertPopUp(){

        this.articleFilter.getTemplateViewModel().idArticle(null);
        this.articleFilter.getTemplateViewModel().article("");
        this.articleFilter.getTemplateViewModel().articleObj("");
        this.getTemplateViewModel().articleInsertPreviewCode("");
    }

    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions)
        this.imagePicker.setPermissions(permissions);
        this.tagPicker.setPermissions(permissions);
    }

    public cancelEdit() {

        this.caller.redirectToInteractionEmailList()
    }

    public addTagPickerValidationClass() {

        document.body.classList.add('_tagpicker')
    }

    public removeTagPickerValidationClass() {

        document.body.classList.remove('_tagpicker')
    }

    public onChangeSelectTag() {

        let productsViewModel = this.filterProducts.getTemplateViewModel();
        let typesViewModel = this.filterProductTypes.getTemplateViewModel();
        let productTag = ! productsViewModel.addNewSelected() ?  productsViewModel.optionObj() : null;
        let tagType = ! typesViewModel.addNewSelected() ? typesViewModel.optionObj() : null;
        let specValues = productTag && productTag.specifications_extra ? JSON.parse( JSON.stringify(productTag.specifications_extra)) : [];

        let tagExtra = productTag && productTag.details ? JSON.parse( JSON.stringify(productTag.details)) : [];

        let seoDescription = tagExtra.shortDescription ? tagExtra.shortDescription : null;
        let productText = tagExtra.description ? tagExtra.description : null;
        let affiliateLinks = tagExtra.affiliateLinks ? tagExtra.affiliateLinks : [];
        let image = tagExtra.image ? tagExtra.image : null;

        this.getTemplateViewModel().reviewItemSeoDescription(seoDescription);
        this.getTemplateViewModel().reviewItemAffiliateLinks(affiliateLinks);

        this.caller.setReviewText(productText);

        if(image){

            this.addProductImage(image);
        }

        /*
            Here, the plan is, if you have a type and a product, get specifications extra from tag type field values extra
            otherwise if you only have a type, query for the fields only with

         */

        let specs = [], spec;

        if ( tagType && typeof tagType.fields != "undefined" && tagType.fields.length > 0 ) {

            tagType.fields.forEach( field => {

                spec = {fieldId: field.id, label: field.label, data: null,  dataType: field.dataType};

                for (let i=0; i< specValues.length; i++ ) {

                    if (specValues[i].idField == field.id ) {

                        spec['data'] = specValues[i].value;
                        specValues.splice(i,1);
                        break;
                    }
                }
                specs.push(spec);
            } )
        }
        if (productTag && productTag.details && productTag.details.image) {

            this.getTemplateViewModel().tagImage(productTag.details.image);
        }

        this.getTemplateViewModel().reviewItemTagSpecifications(specs)
    }

    public setProductImages(images) {

        for(let i = 0; i < images.length; i++) {
            this.addProductImage(images[i]);
        }
    }

    public addProductImage(image) {

        let imageSelected = this.getTemplateViewModel().reviewItemImages().find(x => x.id == image.id);
        if (!imageSelected) {
            let images = this.getTemplateViewModel().reviewItemImages();
            images.push(image);
            this.getTemplateViewModel().reviewItemImages([]);
            this.getTemplateViewModel().reviewItemImages(images);
        }
        this.onLoadTemplate('#img_list_product_review .img-article-item', this.reorderReviewItemImages.bind(this));

    }

    private onLoadTemplate(dragItemSelector, sortFunction) {

        var parent = this;
        var dragSrcEl = null;

        function handleDragStart(e) {
            // Target (this) element is the source node.
            dragSrcEl = this;

            //e.dataTransfer.setData('text', 'foo');
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('text/html', this.outerHTML);

            this.classList.add('dragElem');
        }
        function handleDragOver(e) {
            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            let huit_neuf_this = this;
            //var dragItems = document.querySelectorAll('[draggable=true]');
            var dragItems = document.querySelectorAll(dragItemSelector);
            let index = 0;
            let found = false;
            for (let item of dragItems) {
                if (dragSrcEl == item) {

                    huit_neuf_this.classList.add('after');
                    huit_neuf_this.classList.remove('before');
                    found = true;
                    break;
                }
                if (this == item) {

                    huit_neuf_this.classList.add('before');
                    huit_neuf_this.classList.remove('after');
                    found = true;
                    break;
                }
            }

            if (!found) {
                this.classList.add("before");
            }

            e.dataTransfer.dropEffect = 'move';  // See the section on the DataTransfer object.

            return false;
        }

        function handleDragEnter(e) {
            // this / e.target is the current hover target.
            //this.classList.add('over');

            //this.classList.add('before');
        }

        function handleDragLeave(e) {
            this.classList.remove('before');
            this.classList.remove('after');  // this / e.target is previous target element.
        }

        function handleDrop(e) {
            // this/e.target is current target element.

            if (e.stopPropagation) {
                e.stopPropagation(); // Stops some browsers from redirecting.
            }

            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            // Don't do anything if dropping the same column we're dragging.
            if (dragSrcEl != this) {


                var dropHTML = e.dataTransfer.getData('text/html');

                if (dropHTML.includes("<li")) {
                    for (let child of this.parentNode.childNodes) {

                        if (child == dragSrcEl) {
                            this.parentNode.removeChild(dragSrcEl);
                        }
                    }

                    if (this.classList.contains("before")) {
                        this.insertAdjacentHTML('beforebegin', dropHTML);
                        var dropElem = this.previousElementSibling;
                    } else {
                        this.insertAdjacentHTML('afterend', dropHTML);
                        var dropElem = this.nextElementSibling;
                    }

                    addDnDHandlers(dropElem);
                    //this.reorderImages();
                }



            }
            sortFunction(parent);
            this.classList.remove('before');
            this.classList.remove('after');
            return false;
        }

        function handleDragEnd(e) {
            // this/e.target is the source node.
            this.classList.remove('before');
            this.classList.remove('after');

            [].forEach.call(cols, function (col) {
                col.classList.remove('before');
                col.classList.remove('after');
            });
        }

        function addDnDHandlers(elem) {
            elem.addEventListener('dragstart', handleDragStart, false);
            elem.addEventListener('dragenter', handleDragEnter, false)
            elem.addEventListener('dragover', handleDragOver, false);
            elem.addEventListener('dragleave', handleDragLeave, false);
            elem.addEventListener('drop', handleDrop, false);
            elem.addEventListener('dragend', handleDragEnd, false);

        }

        //var dragItems = document.querySelectorAll('[draggable=true]');
        var cols = document.querySelectorAll(dragItemSelector);
        [].forEach.call(cols, addDnDHandlers);
    }

    protected reorderReviewItemImages(huit_neuf_this) {
        let images = huit_neuf_this.getTemplateViewModel().reviewItemImages();
        let selector = '#img_list_product_review .img-article-item';
        let liElements = document.querySelectorAll(selector);

        //reorder the images based on HTML order
        let newImages = []
        for (let element of liElements) {

            let idElement = element.id;
            let image = images.find(i => i.id === Number(element.id));
            if (image) {
                newImages.push(image);
            }
        }
        huit_neuf_this.getTemplateViewModel().reviewItemImages([]);
        huit_neuf_this.getTemplateViewModel().reviewItemImages(newImages);
        huit_neuf_this.onLoadTemplate(selector, huit_neuf_this.reorderReviewItemImages.bind(huit_neuf_this));
    }

    private getFormattedEasternTimeZoneDateTime(): any {

        let date = this.createEasternTimeZoneDateTime();

        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minutes = date.getMinutes();

        return year + '/' + this.padInteger(month,2) + '/' + this.padInteger(day,2) + ' ' + this.padInteger(hour,2) + ':' + this.padInteger(minutes,2);
    }

    private createEasternTimeZoneDateTime(date?: Date): Date {

        if (!date) {
            date = new Date();
        }

        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        //checks if DST is currently being observed, adjusts offset accordingly
        let easternTimeOffset = this.isDstObserved(date) ? -240 : -300;
        date.setMinutes(date.getMinutes() + easternTimeOffset);

        return date;
    }

    private padInteger(number: number, size: number) {
        let s = number+"";
        while (s.length < size) s = "0" + s;
        return s;
    }

    public isDstObserved (date?: Date) {
        let jan = new Date(date.getFullYear(), 0, 1);
        let jul = new Date(date.getFullYear(), 6, 1);
        let stdTimezoneOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());

        return date.getTimezoneOffset() < stdTimezoneOffset;
    }

    public removeValidationClass() {

        document.body.classList.remove('_form-sub')
    }

    public handleTagInArticle(target: string): void {
        switch(target) {
            case 'tag_picker_edit_cancel':

                this.caller.clearValidationErrors();
                this.removeTagPickerValidationClass();
                this.tagPicker.tagEdit.hide();
                break;
            case 'tag_picker_edit':

                this.tagPicker.tagEdit.setTag(this.caller.getTagToEdit());
                this.tagPicker.tagEdit.show();
                break;
        }
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/newsletterInteractionEmailEdit_template.ts